import { render } from "./header-with-logo-auth-screen.vue?vue&type=template&id=513f7c6a"
import script from "./header-with-logo-auth-screen.vue?vue&type=script&lang=ts"
export * from "./header-with-logo-auth-screen.vue?vue&type=script&lang=ts"
script.render = render

export default script